import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import theme from '@/config/theme';

/** Falha de leitura é informativa: não altera o valor salvo nem bloqueia a navegação. */
export const ChecklistImageLoadNotice = ({ uri, onRetry, testID }: {
  uri: string | null;
  onRetry: () => void;
  testID: string;
}) => (
  <View testID={testID} style={styles.container}>
    <Text style={styles.message}>{/^https?:/i.test(uri ?? '')
      ? 'Imagem online indisponível. Verifique a conexão e tente novamente.'
      : 'Não foi possível abrir a imagem neste aparelho. Tente novamente.'}</Text>
    <TouchableOpacity testID={`${testID}-retry`} accessibilityRole="button"
      onPress={onRetry} style={styles.button}>
      <Text style={styles.buttonText}>Tentar novamente</Text>
    </TouchableOpacity>
  </View>
);

const styles = StyleSheet.create({
  container: { width: '100%', gap: 8, padding: 10, marginVertical: 6,
    borderRadius: theme.borderRadius.sm, backgroundColor: theme.colors.background.secondary },
  message: { fontSize: 12, lineHeight: 18, color: theme.colors.text.secondary },
  button: { alignSelf: 'flex-start', paddingVertical: 8, paddingHorizontal: 10,
    borderRadius: theme.borderRadius.sm, borderWidth: 1, borderColor: theme.colors.border.light },
  buttonText: { fontSize: 12, color: theme.colors.primary.default },
});
